<template>
    <div class="collect-wrapper">
        <div class="collect-content">

            <template v-if="activityStatus != 4 || (activityStatus == 4 && !finishPage.isFinish)">
                <!-- 活动未结束 或者已结束 但是不使用结束图片 -->
                <template v-if="loadingStatus == 0">
                    <div class="loading-page" :style="loadingPageStyle">
                        <img class="loading-img" :style="loadingImgStyle"
                            :src="loadingPage.loadingImg && loadingPage.loadingImg.url" />
                    </div>
                </template>

                <template v-if="loadingStatus == 1">
                    <!-- 是新用户 同时使用引导页面 -->
                    <div v-if="userStatus.newUser === true && guidePage.useGuide" class="guide-page"
                        :style="guidePageStyle" @touchmove.prevent @mousewheel.prevent @click="changeUserStatus">
                        {{userStatus.newUser}}
                    </div>

                    <template>
                        <fragment v-for="(parentItem, parentIndex) in parentList" :key="parentIndex">
                            <!-- 遍历父级页面 -->
                            <!-- 图片 组件 -->
                            <NewImg v-if="parentItem.name === 'img'" :info="parentItem" :activityId="activityId"
                                :activityStatus="activityStatus" :activityType="activityType"
                                @handleImgClick="handleImgClick" />

                            <!-- 音频 组件 -->
                            <NewAudio v-if="parentItem.name === 'audio'" :info="parentItem" :activityId="activityId"
                                :activityStatus="activityStatus" :activityType="activityType"
                                @handleAudioClick="handleAudioClick" />

                            <!-- 视频 组件 -->
                            <NewVideo v-if="parentItem.name === 'video'" :info="parentItem" :activityId="activityId"
                                :activityStatus="activityStatus" :activityType="activityType"
                                @handleVideoClick="handleVideoClick" />

                            <!-- 悬浮左 组件 -->
                            <FixLeft v-if="parentItem.name === 'fixLeft'" :info="parentItem" :activityId="activityId"
                                :activityStatus="activityStatus" :activityType="activityType"
                                @handleFixClick="handleFixClick" />

                            <!-- 悬浮右 组件 -->
                            <FixRight v-if="parentItem.name === 'fixRight'" :info="parentItem" :activityId="activityId"
                                :activityStatus="activityStatus" :activityType="activityType"
                                @handleFixClick="handleFixClick" />

                            <!-- 集卡组件 -->
                            <fragment v-if="parentItem.name === 'collect'">
                                <div :key="index" v-for="(item, index) in parentItem.list">
                                    <!-- 这里对原有的数据进行替换 原来是info.list -->

                                    <CardArea v-if="item.name === 'cardArea'" :info="item" :pageDetail="pageDetail"
                                        :receiveData="emitData" @emitEvent="receiveEvent" /> <!-- 卡片区域 -->

                                    <CollectShareArea v-else-if="item.name === 'collectShareArea'" :info="item"
                                        :pageDetail="pageDetail" :receiveData="emitData" @emitEvent="receiveEvent" />
                                    <!-- 集卡分享区域 -->

                                    <ExchangePrizeArea v-else-if="item.name === 'exchangePrizeArea'" :info="item"
                                        :pageDetail="pageDetail" :receiveData="emitData" @emitEvent="receiveEvent" />
                                    <!-- 奖品区域 -->

                                    <ExchangeListArea v-else-if="item.name === 'exchangeListArea'" :info="item"
                                        :pageDetail="pageDetail" :receiveData="emitData" @emitEvent="receiveEvent" />
                                    <!-- 获取的奖品列表 -->

                                </div>

                            </fragment>


                        </fragment>

                    </template>
                </template>
            </template>

            <template v-else>
                <!-- 已结束 且到了结束时间  -->
                <div class="finish-page" :style="finishPageStyle">
                </div>
            </template>

        </div>
    </div>
</template>

<script>

import config from '@/config'  // 这里是小程序跳转相关的配置

import { getQueryString, } from '@/utils/utils'
import { Url } from '@/utils/url'

import { CardArea, CollectShareArea, ExchangePrizeArea, ExchangeListArea } from './components'

const URL = new Url()

/**
 * 事件列表
 * loading 图片
 * 新用户 变更为老用户
 * 点击卡片
 * 点击集卡 集卡次数不够 集卡成功 集卡失败
 * 点击分享 分享页面 需要在 小程序端来完成 h5监听不到事件  分享卡片 仅分享活动 或者分享卡片  微信和支付宝的分享行为不一样
 * 点击奖品 预览奖品
 * 点击兑换 唤起兑换选择 兑换完成 奖品类型虚拟奖品 奖品类型实物奖品 兑换实物奖品 有填写物流
 * 点击奖品列表里的每一项 虚拟奖品 弹出奖品
 * type: '事件类型', data: '相关的数据', options: '额外的配置项' data 业务数据 options 额外的状态或者别的信息
 * 子组件 孙组件尽量少获取和组装数据 尽量把获取和组装数据的职能放在 父组件 子组件中。减少获取和处理数据的组件开销 底层的数据放在子组件 孙组件中处理
 * 组件中传递的事件 和 数据 尽量在当前组件内中止 ，不朝 顶级页面传递 因为后续不同活动传递的事件可能差异很大
 * 各个子组件 孙组件的 事件调用和数据传递 如果不涉及接口调用 则中止于子组件 不朝顶级组件传递
 * 涉及到接口调用的逐级上升到顶级组件去处理 接口调用的结果 也从顶级组件逐步向下传递
 */


export default {

    name: 'Collect',

    provide() {
        return { // $$ inject引用 $ computed 引用
            $$activityId: this.activityId,

            $$activityStatus: () => this.activityStatus,

            $$activityType: this.activityType,

            $$cardList: () => this.pageDetail && this.pageDetail.cardList || []
        }
    },

    components: {

        CardArea, // 卡片区域

        CollectShareArea, // 集卡分享区域

        ExchangePrizeArea, // 兑换奖品区域

        ExchangeListArea, // 已经兑换到的奖品列表区域

    },

    props: {

        info: { // 当前组价的配置信息
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        pageContent: { // 当前页面配置的活动内容
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        pageConfigContent: { // 活动配置的一些特殊的页面内容
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        activityId: { // 活动id
            type: String,
            required: true,
            default: '',
        },

        openId: { // openid
            type: String,
            required: true,
            default: '',
        },

        activityStatus: {  //活动状态 (0,"未发布"),(1,"已发布"),(2,"未开始"),(3,"进行中"),(4,"已结束"),
            type: Number,
            required: true,
            default: 3,
        },

        activityType: { // 活动类型
            type: Number,
            required: true,
            default: 3,
        },

        parentList: { // 父级列表
            type: Array,
            required: true,
            default: () => []
        }

    },

    watch: {
        loadingStatus: { // check 页面加载状态 重新赋值缓存的数据 进而触发子组件的事件
            handler(val) {
                if (val) {
                    let cacheEmitData = this.emitData
                    setTimeout(() => {
                        this.emitData = cacheEmitData
                    }, 50)
                }
            },
            deep: false
        },
        userStatus: { // check 用户状态 重新赋值缓存的数据 进而触发子组件的事件
            handler(val) {
                if (val) {
                    let cacheEmitData = this.emitData
                    setTimeout(() => {
                        this.emitData = cacheEmitData
                    }, 50)
                }
            },
            deep: true
        },
    },

    data() {
        return {

            loadingStatus: 0, // 0 未加载完 1 加载完

            loadingPageStyle: {}, // 加载页样式

            loadingImgStyle: {}, // 加载动画样式

            guidePageStyle: {}, // 引导用户状态

            finishPageStyle: {}, // 结束页面样式

            userStatus: {
                newUser: false,
                hasPhone: false
            }, // 用户状态

            pageDetail: {}, // 所有的活动数据详情

            emitData: {}, // 朝各个子组件传递的数据

        }
    },

    computed: {

        loadingPage() { // 加载图片内容
            // return this.pageConfigContent && this.pageConfigContent.loadingPage || {}
            return {}
        },

        guidePage() { // 新用户引导图片
            return this.pageConfigContent && this.pageConfigContent.guidePage || {}
        },

        finishPage() { // 活动结束展示的页面 自定义 isFinish 取代 useFinish
            return this.pageConfigContent && this.pageConfigContent.finishPage || {}
        },

    },

    mounted() {

        this.init()

    },

    methods: {

        async init() {

            this.initLoadingStatus()

            this.initGuideStyle()

            this.initFinishStatus()

            await this.getUserStatus()

            await this.getActivityStatus()

            await this.getPageDetail()

            await this.processQueryParams()

        },

        initLoadingStatus() { // 初始化加载页状态
            let _loadingStatus = sessionStorage.getItem('_loadingStatus') // 同一个 session内 加载动画只触发一次
            if (_loadingStatus) {
                this.loadingStatus = 1
                return
            }
            let loadingPage = this.loadingPage
            if (!loadingPage.useLoading) {
                this.loadingStatus = 1
            } else {
                const { loadingBg, loadingDuration, loadingImg } = loadingPage
                this.loadingPageStyle = {
                    backgroundImage: `url(${loadingBg.url})`,
                    backgroundSize: `100% 100%`,
                    backgroundPosition: `0px 0px`,
                }
                this.loadingImgStyle = {
                    width: '100%',
                    height: `${(375 * loadingImg.height) / loadingImg.width}px `
                }
                setTimeout(() => {
                    this.loadingStatus = 1
                    sessionStorage.setItem('_loadingStatus', 1) // 加载完动画后将加载过的状态缓存在本地
                }, loadingDuration && loadingDuration * 1000 || 3000)
            }
        },

        initGuideStyle() { // 初始化引导页样式
            let guidePage = this.guidePage
            let { guideImg } = guidePage
            if (guideImg && guideImg.url) {
                this.guidePageStyle = {
                    backgroundImage: `url(${guideImg.url})`,
                    backgroundSize: `100% 100%`,
                    backgroundPosition: `0px 0px`,
                }
            }
        },

        initFinishStatus() { // 初始化结束状态
            let finishPage = this.finishPage
            let { finishImg, finishImgBegin, useFinish } = finishPage
            if (!useFinish) {
                this.$set(this.finishPage, 'isFinish', false)
            } else {
                let finishTime = (new Date(finishImgBegin)).valueOf()
                let currentTime = Date.now()
                if (currentTime > finishTime || currentTime == finishTime) {
                    this.$set(this.finishPage, 'isFinish', true)
                    this.finishPageStyle = {
                        backgroundImage: `url(${finishImg.url})`,
                        backgroundSize: `100% 100%`,
                        backgroundPosition: `0px 0px`,
                    }
                } else {
                    this.$set(this.finishPage, 'isFinish', false)
                }
            }
        },

        async processQueryParams() { // 处理路由参数 路由参数最后处理 先把页面需要的信息展示出来
            let winRecordId = getQueryString("winRecordId")
            let cardId = Number(getQueryString("cardId"))
            if (winRecordId) {
                this.emitData = {
                    type: 'receiveCardInit',
                    data: {
                        winRecordId,
                        cardId,
                    },
                    options: null
                }
            }
        },

        async getUserStatus() { // 获取用户状态
            let params = {
                activityId: this.activityId,
                openId: this.openId
            }
            let res = await this.$fetch({ url: "/ehs/king/user/info", method: "post" }, params)
            if (res.success) {
                this.userStatus = res.model
            }
        },

        async getActivityStatus() { // 获取活动状态 包括签约的状态 这个api暂时不用
            let params = {
                activityId: this.activityId,
                openId: this.openId
            }
            let res = await this.$fetch({ url: "/ehs/king/activity/status", method: "post" }, params)
        },

        async getPageDetail() { // 查询到页面使用到的全部数据 主要是配置项数据
            let params = {
                activityId: this.activityId,
                openId: this.openId,
                winRecordId: getQueryString("winRecordId") || ''
            }
            let res = await this.$fetch({ url: "/ehs/king/card/detail", method: "post" }, params)
            this.pageDetail = res.model || {}
        },

        async attendActivityApi() { // 参加活动 新用户变更为老用户
            let params = {
                activityId: this.activityId,
                openId: this.openId
            }
            return this.$fetch({ url: "/ehs/king/activity/attend", method: "post" }, params)
        },

        async collectCardApi() { // 点亮卡片
            let params = {
                activityId: this.activityId,
                openId: this.openId
            }
            return this.$fetch({ url: "/ehs/king/card/collect", method: "post" }, params)
        },

        async shareActivityCard(data, options) { // 分享卡片 这个接口需要着重看调用过程 [type: activity, card] [recordId: 记录id] 这个接口放小程序端调用
            let params = {
                activityId: this.activityId,
                openId: this.openId,
            }
            if (options.type === 'card') {
                params.winRecordId = data.winRecordId
            }
            return this.$fetch({ url: "ehs/king/share/activity", method: "post" }, params)
        },

        async checkExchangeStatus(data) { // 检查兑换状态
            let params = {
                activityId: this.activityId,
                openId: this.openId,
                exchangePrizeId: data.prizeId
            }
            return this.$fetch({ url: "/ehs/king/preCheck", method: "post" }, params)
        },

        async exchangePrize(exchangeObj) { // 兑换奖品
            let params = {
                activityId: this.activityId,
                openId: this.openId,
                exchangePrizeId: exchangeObj.exchangePrizeId,
                cardIdList: exchangeObj.cardIdList,
            }
            return this.$fetch({ url: "/ehs/king/exchange", method: "post" }, params)
        },

        async addAddress(info) { // 添加地址信息
            let params = {
                activityId: this.activityId,
                openId: this.openId,
                recordId: info.recordId,
            }

            let addParams = (val) => {
                let addressParamList = ['phone', 'name', 'address', 'remark', 'other']
                let addtion = {}
                for (let item of addressParamList) {
                    if (val.hasOwnProperty(item) && val[item]) {
                        addtion[item] = val[item]
                    }
                }
                return addtion
            }
            params = Object.assign(params, addParams(info))

            return this.$fetch(
                { url: "/ehs/king/address/add/v2", method: "post" },
                params
            )
        },

        async viewAddress(info) { // 查看地址信息
            let params = {
                activityId: this.activityId,
                openId: this.openId,
                recordId: info.id
            }
            return this.$fetch({ url: "/ehs/king/address/detail", method: "post" }, params)
        },

        async saveCard(info) { // 领取卡片
            let params = {
                activityId: this.activityId,
                openId: this.openId,
                winRecordId: info.id
            }
            return this.$fetch({ url: "/ehs/king/card/save", method: "post" }, params)
        },

        async changeUserStatus() { // 改变用户状态
            this.$set(this.userStatus, 'newUser', false)
            await this.attendActivityApi()
        },

        async collectCardEvent() {
            let res = await this.collectCardApi()
            this.emitData = {
                type: 'collectCardResponse',
                data: res,
                options: null
            }
            this.afterEventHooks()
        },

        async shareActivityEvent(data, options) { // 分享活动或者卡片 直接跳转小程序页面
            let params = Object.keys(data).reduce((res, key) => { res.push(`${key}=${data[key]}`); return res }, []).join('&')
            let url = () => {
                let { baseUrl, query } = URL.getQueryObject(window.location.href)
                let validateKey = new Set(['activityId', 'pageNo', 'test', 'enterSource'])
                Object.keys(query).forEach(key => {
                    if (!validateKey.has(key)) {
                        delete query[key]
                    }
                })
                return `${baseUrl}${URL.makeQuery(query)}`
            }
            let query = [{ url: url() }, { params }].reduce((res, pairs) => { res.push(Object.keys(pairs).map(key => `${key}=${encodeURIComponent(pairs[key])}`)); return res }, []).join('&')
            let path = `${config.mini.shareUrl}?${query}`
            this.interactMini({
                type: 'mini',
                url: path
            })
        },

        async exchangePrizeEvent(data, options) { // 兑换奖品
            let res = await this.exchangePrize(data)

            this.emitData = {
                type: 'exchangePrizeResponse',
                data: res,
                options: data
            }
            this.afterEventHooks()
        },

        async receiveCardEvent(data, options) { // 收到卡片事件
            let res = await this.saveCard(data)
            this.emitData = {
                type: 'receiveCardResponse',
                data: res,
                options: options
            }
            this.afterEventHooks()
        },

        async submitAddressEvent(data, options) { // 提交地址事件
            let res = await this.addAddress(data)
            this.emitData = {
                type: 'submitAddressResponse',
                data: res,
                options: options
            }
            this.afterEventHooks()
        },

        viewVirtualEvent(data, options) { // 查看虚拟奖品事件
            this.emitData = {
                type: 'viewVirtualTrigger',
                data: data,
                options: options
            }
        },

        viewNoticeEvent(data, options) { // 查看告知奖品事件
            this.emitData = {
                type: 'viewNoticeTrigger',
                data: data,
                options: options
            }
        },

        addAddressEvent(data, options) { // 添加地址事件
            this.emitData = {
                type: 'addAddressTrigger',
                data: data,
                options: options
            }
        },

        async editAddressEvent(data, options) { // 编辑地址事件
            let res = await this.viewAddress(data)
            if (res.success) {
                this.emitData = {
                    type: 'editAddressTrigger',
                    data: data,
                    options: res.model
                }
            } else {
                this.toast(res.errorMessage || '网络不佳，请稍后重试~')
            }
        },

        afterEventHooks() { // 统一的在事件结束后的钩子函数
            this.getPageDetail()
        },

        receiveEvent(e) { // 接收事件
            let {
                type,
                data,
                options
            } = JSON.parse(JSON.stringify(e))
            this[type] && this[type](data, options)
        },

        toast(txt, duration) { // 封装统一的信息处理函数
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: duration || 2000
            })
        },


        handleImgClick(e) { // 图片点击操作
            this.hotAreaHandleClick(e)
        },

        handleAudioClick(e) { // 音频点击操作
            this.hotAreaHandleClick(e)
        },

        handleVideoClick(e) { // 视频点击操作
            this.hotAreaHandleClick(e)
        },

        handleFixClick(e) { // 悬浮点击操作
            this.hotAreaHandleClick(e)
        },

        hotAreaHandleClick(e) {
            this.$emit("hotAreaHandleClick", e)
        },

    }

}

</script>

<style lang="scss" scoped>
.loading-page {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    .loading-img {
        display: block;
    }
}

.guide-page {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    z-index: 99;
    position: absolute;
    left: 0;
    top: 0;
}

.finish-page {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}
</style>
